import two from "../assets/2.png"
import three from "../assets/3.png"
import minHype from "../assets/minHype.png"
import four from "../assets/4.png"
import five from "../assets/5.png"

import beige from "../assets/fondoBeige.jpg"
import skyblue from "../assets/fondoSkyBlue.jpg"
import pink from "../assets/fondoPink.jpg"
import violet from "../assets/fondoViolet.jpg"
import orange from "../assets/fondoOrange.jpg"
import green from "../assets/fondoGreen.jpg"
import { getAuth, signInWithPopup, TwitterAuthProvider } from "firebase/auth";
import { firebaseAuth } from "./fireBase/fireBase.js";


export const builderImage = (color) => {
    let image = beige
    if (color === "beige") {
        image = beige
    }
    else if (color === "skyblue") {
        image = skyblue
    }
    else if (color === "pink") {
        image = pink
    }
    else if (color === "violet") {
        image = violet
    }
    else if (color === "orange") {
        image = orange
    }
    else if (color === "green") {
        image = green
    }

    return image
}

export const pageColor = (color) => {
    let style = { backgroundColor: "#CEB280" }
    if (color === "green") style.backgroundColor = "#a7c957"
    else if (color === "orange") style.backgroundColor = "#fe7f2d"
    else if (color === "violet") style.backgroundColor = "#9d4edd"
    else if (color === "pink") style.backgroundColor = "#ffafcc"
    else if (color === "skyblue") style.backgroundColor = "#68c5d1"
    else if (color === "beige") style.backgroundColor = "#CEB280"
    return style
}

export const gradientColor = (color) => {
    let style = { background: 'linear-gradient(140deg,#CEB280 0%, #D7A145 31.99%, #9C8660 66.06%, #4F3B19 100%)' }
    if (color === "green") style.background = "linear-gradient(140deg,#C1D29A 0%, #A7C957 31.99%, #7D9641 66.06%, #444A36 100%)"
    else if (color === "orange") style.background = "linear-gradient(140deg,#FFAF7A 0%, #FE7F2D 31.99%, #CC6825 66.06%, #804117 100%)"
    else if (color === "violet") style.background = "linear-gradient(140deg,#C094E3 0%, #9D4EDD 31.99%, #793CAB 66.06%, #4F3D5E 100%)"
    else if (color === "pink") style.background = "linear-gradient(140deg,#FFAFCC 0%, #FF639C 31.99%, #CC8DA4 66.06%, #80324E 100%)"
    else if (color === "skyblue") style.background = "linear-gradient(140deg,#ADD4D9 0%, #68C5D1 31.99%, #294D52 66.06%, #415052 100%)"
    else if (color === "beige") style.background = "linear-gradient(140deg,#CEB280 0%, #D7A145 31.99%, #9C8660 66.06%, #4F3B19 100%)"
    return style
}

export const gradientBorder = (color) => {
    let style = { borderImage: 'linear-gradient(140deg,#CEB280 0%, #D7A145 31.99%, #9C8660 66.06%, #4F3B19 100%)1' }
    if (color === "green") style.borderImage = "linear-gradient(140deg,#C1D29A 0%, #A7C957 31.99%, #7D9641 66.06%, #444A36 100%)1"
    else if (color === "orange") style.borderImage = "linear-gradient(140deg,#FFAF7A 0%, #FE7F2D 31.99%, #CC6825 66.06%, #804117 100%)1"
    else if (color === "violet") style.borderImage = "linear-gradient(140deg,#C094E3 0%, #9D4EDD 31.99%, #793CAB 66.06%, #4F3D5E 100%)1"
    else if (color === "pink") style.borderImage = "linear-gradient(140deg,#FFAFCC 0%, #FF639C 31.99%, #CC8DA4 66.06%, #80324E 100%)1"
    else if (color === "skyblue") style.borderImage = "linear-gradient(140deg,#ADD4D9 0%, #68C5D1 31.99%, #294D52 66.06%, #415052 100%)1"
    else if (color === "beige") style.borderImage = "linear-gradient(140deg,#CEB280 0%, #D7A145 31.99%, #9C8660 66.06%, #4F3B19 100%)1"
    return style
}


export const sortNumber = (projects, type) => {
    let allProjects = projects.slice().sort((a, b) => {
        if (type === "floorChange" || type === "volumeChange") {
            let aNoPorcent = a[type].slice(0, -1)
            let bNoPorcent = b[type].slice(0, -1)
            return bNoPorcent - aNoPorcent

        }else if(type ==="owners" || type === "items"){
            let aComma = a[type].replace(",", "")
            let bComma = b[type].replace(",", "")
            return bComma - aComma
        } else{
            return b[type] - a[type]
        }
    })
    return allProjects
}

export const communitySort = (test) => {
    let allProjects = test
    allProjects = allProjects.slice().sort((a, b) => {
        let aNumber;
        let bNumber;
        let aFollowers;
        let bFollowers;
        if (a?.twitterFollowers?.includes("K")) {
            aNumber = a?.twitterFollowers?.split("K", 1)
            aFollowers = aNumber[0] * 1000
        } else if (a?.twitterFollowers?.includes("Followers")) {
            aNumber = a?.twitterFollowers?.split("Followers", 1)
            aFollowers = aNumber[0].trim().replace(",", "")
        } else if (a?.twitterFollowers?.includes("Seguidores")) {
            aNumber = a?.twitterFollowers?.split("Seguidores", 1)
            aFollowers = aNumber[0].trim().replace(".", "")
        }
        if (b?.twitterFollowers?.includes("K")) {
            bNumber = b?.twitterFollowers?.split("K", 1)
            bFollowers = bNumber[0] * 1000

        } else if (b?.twitterFollowers?.includes("Followers")) {
            bNumber = b?.twitterFollowers?.split("Followers", 1)
            bFollowers = bNumber[0].trim().replace(",", "")
        } else if (b?.twitterFollowers?.includes("Seguidores")) {
            bNumber = b?.twitterFollowers?.split("Seguidores", 1)
            bFollowers = bNumber[0].trim().replace(".", "")
        }


        if (!aFollowers && !bFollowers) {
            return 0
        }
        if (!aFollowers) {
            return 1
        }
        else if (!bFollowers) {
            return -1
        } else {
            return bFollowers - aFollowers
        }
    })
    return allProjects
}

export const sort_user_likes = (projects)=>{
    const allProjects = projects.slice().sort((a, b) => {
        return b.userLikes.length - a.userLikes.length
    })
    return allProjects
}

export const marketSort = (projects) => {
    projects = projects.slice().sort((a, b) => {
        let aNumber;
        let bNumber;
        let aVolume;
        let bVolume;
        if (a?.totalVolume?.includes("k")) {
            aNumber = a?.totalVolume?.split("k", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000
        } else if (a?.totalVolume?.includes("M")) {
            aNumber = a?.totalVolume?.split("M", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000000
        } else {
            aVolume = a.totalVolume?.trim().replace(",", ".")
        }
        if (b?.totalVolume?.includes("k")) {
            bNumber = b?.totalVolume?.split("k", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000
        } else if (b?.totalVolume?.includes("M")) {
            bNumber = b?.totalVolume?.split("M", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000000
        } else {
            bVolume = b.totalVolume?.trim().replace(",", ".")

        }

        if (!aVolume && !bVolume) {
            return 0
        }
        if (!aVolume) {
            return 1
        }
        else if (!bVolume) {
            return -1
        } else {
            return bVolume - aVolume
        }
    })
    return projects
}

export const volumeSort = (projects) => {
    projects = projects.slice().sort((a, b) => {
        let aNumber;
        let bNumber;
        let aVolume;
        let bVolume;
        // console.log(a.volumeToday,b.volumeToday,"numeros")
        if (a?.volumeToday?.includes("k")) {
            aNumber = a?.volumeToday?.split("k", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000
        } else if (a?.volumeToday?.includes("M")) {
            aNumber = a?.volumeToday?.split("M", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000000
        } else {
            aVolume = a.volumeToday?.trim().replace(",", ".")
        }
        if (b?.volumeToday?.includes("k")) {
            bNumber = b?.volumeToday?.split("k", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000
        } else if (b?.volumeToday?.includes("M")) {
            bNumber = b?.volumeToday?.split("M", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000000
        } else {
            bVolume = b.volumeToday?.trim().replace(",", ".")

        }

        // console.log(aVolume,bVolume,"------",bVolume - aVolume)
        if (aVolume === "-") return 1
        if (bVolume === "-") return -1
        if (!aVolume && !bVolume) {
            return 0
        }
        if (!aVolume) {
            return 1
        }
        else if (!bVolume) {
            return -1
        } else {
            return bVolume - aVolume
        }
    })
    return projects
}

export const hypeLevel = (hype) => {
    let imageHype = minHype
    let imageClass = "minHype"
    if (hype > 30) {
        imageHype = two
        imageClass = "two"
    }
    if (hype > 70) {
        imageHype = three
        imageClass = "three"

    }
    if (hype > 130) {
        imageHype = four
        imageClass = "four"

    }
    if (hype > 150) {
        imageHype = five
        imageClass = "five"

    }
    // if(hype > 300){
    //     imageHype = maxHype
    //     imageClass = "maxHype"
    // } 
    return { imageHype, imageClass }
}
export const sortFloorPrice = (projects) => {
    projects = projects.slice().sort((a, b) => {
        let aNumber;
        let bNumber;
        let aVolume;
        let bVolume;
        // console.log(a.volumeToday,b.volumeToday,"numeros")
        if (a?.floorPrice?.includes("k")) {
            aNumber = a?.floorPrice?.split("k", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000
        } else if (a?.floorPrice?.includes("M")) {
            aNumber = a?.floorPrice?.split("M", 1)
            aVolume = aNumber[0].trim().replace(",", ".") * 1000000
        } else {
            aVolume = a.floorPrice?.trim().replace(",", ".")
        }
        if (b?.floorPrice?.includes("k")) {
            bNumber = b?.floorPrice?.split("k", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000
        } else if (b?.floorPrice?.includes("M")) {
            bNumber = b?.floorPrice?.split("M", 1)
            bVolume = bNumber[0].trim().replace(",", ".") * 1000000
        } else {
            bVolume = b.floorPrice?.trim().replace(",", ".")

        }

        console.log(aVolume, bVolume, "------", bVolume - aVolume)
        if (isNaN(aVolume)) return 1
        if (isNaN(bVolume)) return -1
        if (!aVolume && !bVolume) {
            return 0
        }
        if (!aVolume) {
            return 1
        }
        else if (!bVolume) {
            return -1
        } else {
            return bVolume - aVolume
        }
    })
    return projects
}



export const signInWithTwitter = async (handleClose) => {
    console.log("anda bien")
    const provider = new TwitterAuthProvider();
    let response;
    await signInWithPopup(firebaseAuth, provider)
        .then((result) => {
            // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
            // You can use these server side with your app's credentials to access the Twitter API.
            const credential = TwitterAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            const secret = credential.secret;

            // The signed-in user info.
            const user = result.user;
            const name = user.displayName
            const id = user.uid
            console.log({ name, id })
            console.log({ user })

            // IdP data available using getAdditionalUserInfo(result)
            // ...
            response = { ok: true, name, id }
        }).catch((error) => {
            console.log(error)
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = TwitterAuthProvider.credentialFromError(error);
            // ...
            response = { ok: false, msg: error }
        });
    handleClose()
    return response
}

// module.exports = {
//     communitySort,
//     marketSort,
//     volumeSort,
//     hypeLevel
// }